/* eslint-disable */
import "./journalists"